<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep, groupBy } from "lodash";
import { required, maxLength } from "vuelidate/lib/validators";
import PrexcClassification from '@/components/modals/prexc-classification.vue';
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";

export default {
    page: {
        title: "Outcomes",
    },
    components: {
        Layout,
        PageHeader,
        // SectoralOutcome,
        PrexcClassification,
        MaskedInput
    },
    data() {
        return {
            title: "Strategic Goals & Outcomes",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Strategic Goals & Outcomes",
                    active: true,
                },
            ],
            tableData: [],
            modalTitle: "",
            outcome: {
                id: 0,
                outcomeName: "",
                uacs: "",
                sectoralOutcomeId: "",
                agencyId: this.$store.state.data.agency.id,
            },
            sectoralOutcome: {},
            tableBusy: false,
            prexc: {
                id: 0,
                uacs: "",
                prexcName: "",
                prexcClassificationId: null,
                outcomeId: null,
            },
            sectoral: {
                id: 0,
                societalOutcomeId: "",
                outcome: "",
            },
            societal: {
                id: 0,
                outcome: "",
            },
            selectedPrexc: null,
            selectedOutcome: null,
            selectedSectoral: null,
            selectedSocietal: null,
            copiedPrexc: null,
            filterKey: "",
            addPAType: 'item',
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: false,
            }),
        };
    },
    validations: {
        outcome: {
            outcomeName: { required },
        },
        prexc: {
            prexcName: { required, maxLength: maxLength(500) },
            prexcClassificationId: { required },
        },
        sectoral: {
            outcome: { required },
        },
        societal: {
            outcome: { required },
        },
    },
    created() {
        this.tableBusy = true;
        this.totalRows = this.items.length;
        this.$store
            .dispatch("societaloutcome/GetSocietalOutcome")
            .then((res) => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error');
                }
                res.data.map(item => {
                    item.filterKey = `${item.outcome}`
                    item.sectoralOutcomes.map(x => {
                        item.filterKey += ` ${x.outcome}`
                        x.filterKey = `${x.outcome}`
                        x.outcomes.map(y => {
                            item.filterKey += ` ${y.outcomeName}`
                            x.filterKey += ` ${y.outcomeName}`
                            y.filterKey = `${item.outcome} ${x.outcome} ${y.outcomeName}`
                            y.prexcs = [];
                            y.viewPrexc = false;
                        })
                    })
                })
                this.tableData = res.data;
                this.tableBusy = false;
            })
            .catch(() => {
                this.tableBusy = false;
                this.showToast("Something went wrong!","error");
            });
    },
    computed: {
        filtered(){
            if(this.filterKey == ""){
                return this.tableData;
            }
            return this.tableData.filter(x => x.filterKey.toLowerCase().includes(this.filterKey.toLowerCase()));
        }
    },
    methods: {
        async viewPrexc(data) {
            data.viewPrexc = !data.viewPrexc;
            if(data.prexcs.length == 0){
                data.prexcLoading = true;
                await this.getPrexcs(data);
                data.prexcLoading = false;
            }
        },
        async getPrexcs(data) {
            await this.$store
                .dispatch("prexc/GetPrexcByOutcome", data.id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    let grpData = [];
                    let grpClass = groupBy(res.data, "prexcClassificationId");
                    for (const [key, value] of Object.entries(grpClass)) {
                        let cls = value[0].prexcClassification;
                        grpData.push({
                            id: cls.id,
                            classification: cls.classification,
                            priority: cls.priority,
                            prexcs: value,
                        });
                    }
                    data.prexcs = grpData;
                })
                .catch(() => {
                    this.showToast("Something went wrong!","error");
                });
        },
        addProgramArea(data, outcome, type){
            this.addPAType = type;
            this.selectedPrexc = data;
            this.selectedOutcome = outcome;
            if(data && data.prexcs.length == 1 && data.prexcs[0].prexcName === '0x0x0x0x' && data.prexcs[0].uacs === '0x0x0x0x'){
                this.prexc = {
                    id: data.prexcs[0].id,
                    uacs: "",
                    prexcName: "",
                    prexcClassification: {
                        id: data.id,
                        classification: data.classification,
                        priority: data.priority,
                    },
                    prexcClassificationId: data.id,
                    outcomeId: outcome.id,
                    sortData: 1
                };
                this.copiedPrexc = cloneDeep(this.prexc);
            }else{
                this.prexc = {
                    id: 0,
                    uacs: !data ? "0x0x0x0x" : "",
                    prexcName: !data ? "0x0x0x0x" : "",
                    prexcClassification: {
                        id: !data ? null : data.id,
                        classification: !data ? null : data.classification,
                        priority: !data ? null : data.priority,
                    },
                    prexcClassificationId: !data ? null : data.id,
                    outcomeId: outcome.id,
                    sortData: !data ? 1 : data.prexcs.length + 1
                };
            }
            this.modalTitle = !data ? "Create New Program Cluster" :  "Create New Program Area";
            this.$bvModal.show("prexc-modal");
        },
        getPc() {
            this.$refs.pModal.getData();
            this.$bvModal.show("prexc-classification-modal");
        },
        dropPrexcClass(data){
            this.prexc.prexcClassificationId = data.id;
            this.prexc.prexcClassification = data;
        },
        onCreatePrexc(){
            this.submitted = true;
            this.$v.prexc.$touch();
            if (this.$v.prexc.$invalid) {
                return;
            }
            if (this.prexc.id > 0) {
                this.$store
                    .dispatch("prexc/UpdatePrexc", this.prexc)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let grandIndex = this.selectedOutcome.prexcs.findIndex(x => x.id == this.prexc.prexcClassificationId);
                        let copiedIdx = this.selectedOutcome.prexcs.findIndex(x => x.id == this.copiedPrexc.prexcClassificationId);
                        if(grandIndex > -1){
                            if(grandIndex == copiedIdx){
                                let index = this.selectedOutcome.prexcs[grandIndex].prexcs.findIndex(x => x.id == this.prexc.id);
                                this.selectedOutcome.prexcs[grandIndex].prexcs.splice(index, 1, res.data);
                            }else{
                                let index = this.selectedOutcome.prexcs[copiedIdx].prexcs.findIndex(x => x.id == this.prexc.id);
                                this.selectedOutcome.prexcs[copiedIdx].prexcs.splice(index, 1);
                                this.selectedOutcome.prexcs[grandIndex].prexcs.push(res.data);
                                if(this.selectedOutcome.prexcs[copiedIdx].prexcs.length == 0){
                                    this.selectedOutcome.prexcs.splice(copiedIdx, 1);
                                }
                            }
                        }else{
                            let index = this.selectedOutcome.prexcs[copiedIdx].prexcs.findIndex(x => x.id == this.prexc.id);
                            this.selectedOutcome.prexcs[copiedIdx].prexcs.splice(index, 1);
                            this.selectedOutcome.prexcs.push({
                                id: res.data.prexcClassificationId,
                                classification: res.data.prexcClassification.classification,
                                priority: res.data.prexcClassification.priority,
                                prexcs: [this.prexc],
                            });
                            if(this.selectedOutcome.prexcs[copiedIdx].prexcs.length == 0){
                                this.selectedOutcome.prexcs.splice(copiedIdx, 1);
                            }
                        }
                        this.$bvModal.hide("prexc-modal");
                        this.showToast("Successfully updated!","success");
                    })
                    .catch((err) => {
                        console.log(err)
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                this.$store
                    .dispatch("prexc/CreatePrexc", this.prexc)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.selectedOutcome.prexcs.findIndex(x => x.id == this.prexc.prexcClassificationId);
                        if(index > -1){
                            this.selectedOutcome.prexcs[index].prexcs.push(res.data);
                        }else{
                            this.selectedOutcome.prexcs.push({
                                id: res.data.prexcClassificationId,
                                classification: res.data.prexcClassification.classification,
                                priority: res.data.prexcClassification.priority,
                                prexcs: [res.data],
                            });
                        }
                        this.$bvModal.hide("prexc-modal");
                        this.showToast("Successfully created!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        updatePrexc(data, parent, grandParent){
            this.selectedOutcome = grandParent;
            this.selectedPrexc = parent;
            this.copiedPrexc = cloneDeep(data);
            this.prexc = cloneDeep(data);
            this.modalTitle = "Update New Program Area";
            this.$bvModal.show("prexc-modal");
        },
        deletePrexc(row, parent, grandParent){
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    if(row && parent.prexcs.length == 1){
                        let index = parent.prexcs.findIndex(x => x.id == row.id);
                        let data = cloneDeep(row);
                        data.uacs = '0x0x0x0x';
                        data.prexcName = '0x0x0x0x';
                        this.$store
                            .dispatch("prexc/UpdatePrexc", data)
                            .then((res) => {
                                if(res.data.error){
                                    return this.showToast(res.data.errorMessage, 'error');
                                }
                                parent.prexcs.splice(index, 1, data);
                                this.showToast("Successfully deleted!","success");
                            })
                            .catch((err) => {
                                this.showToast("Something went wrong!","error");
                            });
                    }else{
                        let data = null
                        if(!row){
                           data = parent.prexcs[0];
                        }else{
                            data = row;
                        }
                        let index = parent.prexcs.findIndex(x => x.id == data.id);
                        this.$store
                            .dispatch("prexc/DeletePrexc", data.id)
                            .then((res) => {
                                if(res.data.error){
                                    return this.showToast(res.data.errorMessage, 'error');
                                }
                                parent.prexcs.splice(index, 1);
                                if(parent.prexcs.length == 0){
                                    let grandIndex = grandParent.prexcs.findIndex(x => x.id == parent.id);
                                    grandParent.prexcs.splice(grandIndex, 1);
                                }
                                this.showToast("Successfully deleted!","success");
                            })
                            .catch((err) => {
                                this.showToast("Cannot be deleted!","error");
                            });
                    }
                }
            });
        },
        async onCreateOutcome(){
            this.submitted = true;
            this.$v.outcome.$touch();
            if (this.$v.outcome.$invalid) {
                return;
            }
            if (this.outcome.id > 0) {
                let data = cloneDeep(this.outcome);
                await this.$store
                    .dispatch("outcome/UpdateOutcome", this.outcome)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.selectedSectoral.outcomes.findIndex(x => x.id == this.outcome.id);
                        this.selectedSectoral.outcomes.splice(index, 1, data);
                        this.$bvModal.hide("outcome-modal");
                        this.showToast("Successfully updated!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                await this.$store
                    .dispatch("outcome/CreateOutcome", this.outcome)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        res.data.viewPrexc = false;
                        res.data.prexcs = [];
                        this.selectedSectoral.outcomes.push(res.data);
                        this.$bvModal.hide("outcome-modal");
                        this.showToast("Successfully created!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        addOutcome(sectoral){
            this.selectedSectoral = sectoral;
            this.outcome = {
                id: 0,
                outcomeName: "",
                uacs: "",
                sectoralOutcomeId: sectoral.id,
                agencyId: this.$store.state.data.agency.id,
            };
            this.modalTitle = "Create New Outcome";
            this.$bvModal.show("outcome-modal");
        },
        updateOutcome(data, parent){
            this.selectedSectoral = parent;
            this.outcome = cloneDeep(data);
            this.modalTitle = "Update Outcome";
            this.$bvModal.show("outcome-modal");
        },
        deleteOutcome(row, parent){
            var index = parent.outcomes.findIndex(x => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("outcome/DeleteOutcome", row.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            parent.outcomes.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        onCreateSectoral() {
            this.submitted = true;
            this.$v.sectoral.$touch();
            if (this.$v.sectoral.$invalid) {
                return;
            } 
            if (this.sectoral.id > 0) {
                let data = cloneDeep(this.sectoral);
                this.$store
                    .dispatch(
                        "sectoraloutcome/UpdateSectoralOutcome",
                        this.sectoral
                    )
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.selectedSocietal.sectoralOutcomes.findIndex(x => x.id == this.sectoral.id);
                        this.selectedSocietal.sectoralOutcomes.splice(index, 1, data);
                        this.$bvModal.hide("sectoral-modal");
                        this.showToast("Successfully updated!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                this.$store
                    .dispatch(
                        "sectoraloutcome/CreateSectoralOutcome",
                        this.sectoral
                    )
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        res.data.outcomes = [];
                        this.selectedSocietal.sectoralOutcomes.push(res.data);
                        this.$bvModal.hide("sectoral-modal");
                        this.showToast("Successfully created!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        addSectoral(societal){
            this.selectedSocietal = societal;
            this.sectoral = {
                id: 0,
                societalOutcomeId: societal.id,
                outcome: "",
            };
            this.modalTitle = "Create New Sectoral Outcome(s)";
            this.$bvModal.show("sectoral-modal");
        },
        updateSectoral(data, parent){
            this.selectedSocietal = parent;
            this.sectoral = cloneDeep(data);
            this.modalTitle = "Update Sectoral Outcome(s)";
            this.$bvModal.show("sectoral-modal");
        },
        deleteSectoral(row, parent){
            var index = parent.sectoralOutcomes.findIndex(x => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("sectoraloutcome/DeleteSectoralOutcome", row.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            parent.sectoralOutcomes.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        onCreateSocietal() {
            this.submitted = true;
            this.$v.societal.$touch();
            if (this.$v.societal.$invalid) {
                return;
            }
            if (this.societal.id > 0) {
                let data = cloneDeep(this.societal);
                this.$store
                    .dispatch("societaloutcome/UpdateSocietalOutcome", this.societal)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        let index = this.tableData.findIndex(x => x.id == this.societal.id);
                        this.tableData.splice(index, 1, data);
                        this.$bvModal.hide("societal-modal");
                        this.showToast("Successfully updated!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            } else {
                this.$store
                    .dispatch("societaloutcome/CreateSocietalOutcome", this.societal)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, 'error');
                        }
                        res.data.sectoralOutcomes = [];
                        this.tableData.push(res.data);
                        this.$bvModal.hide("societal-modal");
                        this.showToast("Successfully created!","success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!","error");
                    });
            }
            this.submitted = false;
        },
        updateSocietal(data){
            this.societal = cloneDeep(data);
            this.modalTitle = "Update Societal Outcome(s)";
            this.$bvModal.show("societal-modal");
        },
        deleteSocietal(row){
            var index = this.tableData.findIndex(x => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("societaloutcome/DeleteSocietalOutcome", row.id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            this.tableData.splice(index, 1);
                            this.showToast("Successfully deleted!","success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!","error");
                        });
                }
            });
        },
        addSocietal(){
            this.societal = {
                id: 0,
                outcome: "",
            };
            this.modalTitle = "Create New Societal Outcome(s)";
            this.$bvModal.show("societal-modal");
        },
        filterSec(data){
            if(this.filterKey == ""){
                return data;
            }
            return data.filter(x => x.filterKey.toLowerCase().includes(this.filterKey.toLowerCase()));
        },
        filterOutcome(data){
            if(this.filterKey == ""){
                return data;
            }
            return data.filter(x => x.filterKey.toLowerCase().includes(this.filterKey.toLowerCase()));
        },
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="prexc-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreatePrexc"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3" v-if="addPAType == 'item'">
                    <label for="prexcName">UACS Code</label>
                    <input
                        autocomplete="off"
                        type="text"
                        placeholder="Enter UACS Code..."
                        class="form-control"
                        v-model="prexc.uacs"
                    />
                </div>
                <div class="mb-3" v-if="addPAType == 'item'">
                    <label for="prexcName">Program Area Name</label>
                    <textarea
                        id="prexcName"
                        rows="3"
                        v-model="prexc.prexcName"
                        placeholder="Enter Program Area Name..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.prexc.prexcName.$error}"
                    ></textarea>
                    <div v-if="submitted && $v.prexc.prexcName.$error" class="invalid-feedback">
                        <span v-if="!$v.prexc.prexcName.required">This value is required.</span>
                        <span v-if="!$v.prexc.prexcName.maxLength">
                            This value is too long. It should have 500 characters or fewer.
                        </span>
                    </div>
                </div>
                <div class="mb-3" v-if="prexc.prexcClassification && addPAType == 'mother'">
                    <label for="prexcClass"
                        >Program Cluster
                    </label>
                    <b-input-group>
                        <template #append>
                            <b-button @click="getPc" variant="outline-info">
                                <i class="mdi mdi-clipboard-text-search-outline"></i>
                            </b-button>
                        </template>
                        <input
                            autocomplete="off"
                            type="text"
                            disabled
                            placeholder="Search Program Cluster..."
                            class="form-control"
                            v-model="prexc.prexcClassification.classification"
                        />
                    </b-input-group>
                    <div
                        v-if="submitted && $v.prexc.prexcClassificationId.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.prexc.prexcClassificationId.required">This value is required.</span>
                    </div>
                </div>
                <div class="mb-3" v-if="addPAType == 'item'">
                    <label for="sortOrder">Sort Order</label>
                    <masked-input
                        id="sortOrder"
                        v-model="prexc.sortOrder"
                        placeholder="Enter Sort Order..."
                        class="form-control"
                        :mask="currencyMask"
                    />
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('prexc-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="outcome-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateOutcome"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="outcomeName">Outcome Name</label>
                    <textarea
                        autocomplete="off"
                        id="outcomeName"
                        rows="3"
                        v-model="outcome.outcomeName"
                        placeholder="Enter Outcome Name..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.outcome.outcomeName.$error}"
                    ></textarea>
                    <div
                        v-if="submitted && $v.outcome.outcomeName.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.outcome.outcomeName.required">This value is required.</span>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('outcome-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="sectoral-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateSectoral"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="outcome">Sectoral Outcome(s) </label>
                    <input
                        autocomplete="off"
                        id="outcome"
                        type="text"
                        v-model="sectoral.outcome"
                        placeholder="Enter Sectoral Outcome(s)..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted && $v.sectoral.outcome.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.sectoral.outcome.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.sectoral.outcome.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('sectoral-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="societal-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateSocietal"
                class="needs-validation"
                ref="fcForm"
            >
                <div class="mb-3">
                    <label for="outcome">Societal Outcome(s) </label>
                    <input
                        autocomplete="off"
                        id="outcome"
                        type="text"
                        v-model="societal.outcome"
                        placeholder="Enter Outcome..."
                        class="form-control"
                        :class="{
                            'is-invalid':
                                submitted &&
                                $v.societal.outcome.$error,
                        }"
                    />
                    <div
                        v-if="
                            submitted &&
                            $v.societal.outcome.$error
                        "
                        class="invalid-feedback"
                    >
                        <span
                            v-if="!$v.societal.outcome.required"
                            >This value is required.</span
                        >
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="submit"
                        class="btn btn-primary"
                    >
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('societal-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <div>
            <div class="d-flex justify-content-between mb-2">
                <div>
                    <input type="text" class="form-control" placeholder="Search Outcome..." style="width:250px;" v-model="filterKey">
                </div>
                <div>
                    <button type="button" class="btn btn-info" @click="addSocietal"><i class="bx bx-plus"></i>Create Societal Outcome(s)</button>
                </div>
            </div>
            <template v-for="(z, zIndex) in filtered">
                <div :key="`societal-${z.id}`" class="mb-3">
                    <div class="d-flex align-items-center hover-toggle">
                        <span class="bx bx-star text-warning me-1"></span>
                        <h4 class="text-dark mb-0 me-1">Societal Outcome: <i> {{ z.outcome }} </i> </h4>
                        <div class="hover-content gap-1 ms-1">
                            <a href="javascript:void(0);" class="text-primary font-size-14" @click="addSectoral(z)"><i class="bx bx-plus"></i></a>
                            <a href="javascript:void(0);" class="text-success font-size-14" @click="updateSocietal(z, tableData)"><i class="bx bx-edit"></i></a>
                            <a href="javascript:void(0);" class="text-danger font-size-14" @click="deleteSocietal(z, tableData)"><i class="bx bx-trash"></i></a>
                        </div>
                    </div>
                    <template v-for="w in filterSec(z.sectoralOutcomes)">
                        <div class="ms-4 mt-1 mb-1 " :key="`sectoral-${z.id}-${w.id}`">
                            <div class="d-flex align-items-center mb-2 hover-toggle">
                                <span class="bx bx-checkbox-square text-success me-1"></span>
                                <h5 class="text-dark mb-0">Sectoral Outcome:  <i> {{w.outcome}} </i></h5>
                                <div class="hover-content gap-1 ms-1">
                                    <a href="javascript:void(0);" class="text-primary font-size-14" @click="addOutcome(w)"><i class="bx bx-plus"></i></a>
                                    <a href="javascript:void(0);" class="text-success font-size-14" @click="updateSectoral(w, z)"><i class="bx bx-edit"></i></a>
                                    <a href="javascript:void(0);" class="text-danger font-size-14" @click="deleteSectoral(w, z)"><i class="bx bx-trash"></i></a>
                                </div>
                            </div>
                            <h5 class="ms-5">Organizational Outcomes</h5>    
                            <template v-for="(x, xIndex) in filterOutcome(w.outcomes)">
                                <div class="ms-5 mt-1" :key="`outcome-${z.id}-${w.id}-${x.id}`">
                                    <b-card
                                        no-body
                                        class="mt-1 mb-1 shadow-none"
                                        :style="{zIndex: `${tableData.length - zIndex}${w.outcomes.length - xIndex}`}"
                                    >
                                        <b-card-header
                                            header-tag="header"
                                            role="tab"
                                            class="border"
                                        >
                                            <div class="d-flex justify-content-between">
                                                <div>
                                                    <div class="d-flex align-items-center">
                                                        <span class="bx bx-circle text-info me-1" ></span>
                                                        <b class="text-dark">{{x.outcomeName}}</b>
                                                    </div>
                                                    <div class="ms-3">
                                                        <a href="javascript:void(0);" @click="viewPrexc(x)">{{x.viewPrexc ? 'Hide' : 'View'}} Program Area <i class="bx align-middle" :class="[x.viewPrexc ? 'bx-chevron-down' : 'bx-chevron-right']"></i></a>
                                                    </div>
                                                </div>
                                                <div>
                                                    <b-dropdown
                                                        id="dropdown-dropleft"
                                                        right
                                                        variant="link"
                                                        toggle-class="text-decoration-none"
                                                        menu-class="dropdown-menu-end"
                                                        no-caret
                                                    >
                                                        <template #button-content>
                                                            <i class="fas fa-ellipsis-v"></i>
                                                        </template>
                                                        <b-dropdown-item
                                                            @click="updateOutcome(x, w)"
                                                            variant="secondary"
                                                            ><i class="mdi mdi-update font-size-18 me-1"></i
                                                            >Edit</b-dropdown-item
                                                        >
                                                        <b-dropdown-item
                                                            @click="deleteOutcome(x, w)"
                                                            variant="danger"
                                                            ><i
                                                                class="mdi mdi-trash-can font-size-18 me-1"
                                                            ></i
                                                            >Delete</b-dropdown-item
                                                        >
                                                    </b-dropdown>
                                                </div>
                                            </div>
                                        </b-card-header>
                                        <b-collapse
                                            :visible="x.viewPrexc"
                                            :accordion="`prexcGrp-${z.id}-${w.id}-${x.id}`"
                                            role="tabpanel"
                                        >
                                            <b-card-body class="border">
                                                <div class="d-flex justify-content-between align-items-center mb-3">
                                                    <div>
                                                        <h5 class="mb-0">List of Program Area</h5>
                                                        <button @click="addProgramArea(null, x, 'mother')" class="btn btn-success btn-sm" v-if="x.viewPrexc"><i class="bx bx-plus"></i> New Program Cluster</button>
                                                    </div>
                                                </div>
                                                <template v-if="x.prexcs.length">
                                                    <div v-for="y in x.prexcs" :key="`prexcClass-${z.id}-${w.id}-${x.id}-${y.id}`" class="mb-3">
                                                        <div class="d-flex justify-content-between align-items-center mb-1">
                                                            <div class="d-flex align-items-center position-relative my-2 hover-toggle">
                                                                <div style="width:10px;height:10px;border-radius:50%;" class="bg-success me-1"></div>
                                                                <h4 class="mb-0">{{y.classification}}</h4>
                                                                <div class="hover-content">
                                                                    <a href="javascript:void(0);" class="text-danger font-size-14" @click="deletePrexc(null, y, x)"><i class="bx bx-trash"></i></a>
                                                                </div>
                                                            </div>
                                                            <button type="button" class="btn btn-primary btn-sm" @click="addProgramArea(y, x, 'item')"><i class="bx bx-plus"></i> New Program Area</button>
                                                        </div>
                                                        <template v-for="(a, aIndex) in y.prexcs">
                                                            <template v-if="a.uacs === '0x0x0x0x' && a.prexcName === '0x0x0x0x'">
                                                                <h4 :key="`nd${a.id}`" class="ms-4">No data found</h4>
                                                            </template>
                                                            <template v-else>
                                                                <b-card 
                                                                    no-body 
                                                                    class="mb-1 shadow-none ms-4" 
                                                                    :key="`prexc-${z.id}-${w.id}-${x.id}-${y.id}-${a.id}`" 
                                                                    :style="{'zIndex': `${w.outcomes.length - xIndex}${y.prexcs.length - aIndex}`}"
                                                                >
                                                                    <b-card-header
                                                                        header-tag="header"
                                                                        role="tab"
                                                                        class="border"
                                                                    >
                                                                        <div class="d-flex align-items-center justify-content-between">
                                                                            <div class="d-flex align-items-center">
                                                                                <div style="min-width:30px;" class="bg-success bg-gradient text-center me-2 py-1 position-relative">
                                                                                    <h3 class="mb-0 position-relative">{{aIndex + 1}}</h3>
                                                                                </div>
                                                                                <div class="text-muted">
                                                                                    <h5 class="mb-0 d-inline">{{ a.prexcName }}</h5>
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <b-dropdown
                                                                                    id="dropdown-dropleft"
                                                                                    right
                                                                                    variant="link"
                                                                                    toggle-class="text-decoration-none"
                                                                                    menu-class="dropdown-menu-end"
                                                                                    no-caret
                                                                                >
                                                                                    <template #button-content>
                                                                                        <i class="fas fa-ellipsis-v"></i>
                                                                                    </template>
                                                                                    <b-dropdown-item
                                                                                        @click="updatePrexc(a, y, x)"
                                                                                        variant="secondary"
                                                                                        ><i class="mdi mdi-update font-size-18 me-1"></i
                                                                                        >Edit</b-dropdown-item
                                                                                    >
                                                                                    <b-dropdown-item
                                                                                        @click="deletePrexc(a, y, x)"
                                                                                        variant="danger"
                                                                                        ><i
                                                                                            class="mdi mdi-trash-can font-size-18 me-1"
                                                                                        ></i
                                                                                        >Delete</b-dropdown-item
                                                                                    >
                                                                                </b-dropdown>
                                                                            </div>
                                                                        </div>
                                                                    </b-card-header>
                                                                </b-card>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <h4>No data found</h4>
                                                </template>
                                            </b-card-body>
                                        </b-collapse>
                                    </b-card>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </template>
        </div>
        <prexc-classification @dropData="dropPrexcClass($event)" ref="pModal"></prexc-classification>
    </Layout>
</template>